export default function (initRequest) {
    const marketUrl = process.env.REACT_APP_MARKET_URL;
    const URL = process.env.REACT_APP_BASE_URL;
    const JSON = process.env.REACT_APP_JSON_URL;
    const B2cUrl = process.env.REACT_APP_B2C_URL
    return {
        // userLogin: initRequest.des("招标用户登录未发布").post(`/bid/bidLogin/login`),
        userLogin: initRequest.des("营销系统用户登录").post(marketUrl + `/activity/login`),
        

        getBidInfoList: initRequest.des("获取招标信息列表").post(URL+"/bid/getBidInfoList"),
        addBidInfo: initRequest.des("新增招标信息").post(URL+"/bid/addBidInfo"),
        updateBidInfo: initRequest.des("修改招标信息").post(URL+"/bid/updateBidInfo"),

        getValidBidInfoList: initRequest.des("获取所有有效的招标信息").post(URL+"/bid/getValidBidInfoList"),

        getTenderInfoList: initRequest.des("获取投标信息列表").post(URL+"/bid/getTenderInfoList"),
        addTenderInfo: initRequest.des("新增投标信息").post(URL+"/bid/addTenderInfo"),
        updateTenderInfo: initRequest.des("修改投标信息").post(URL+"/bid/updateTenderInfo"),
        
        getBidWinningCompanyList: initRequest.des("获取中标公司信息").post(URL+"/bid/getBidWinningCompanyList"),
        getIndexPageInfo: initRequest.des("获取首页招标信息").post(URL+"/bid/getIndexPageInfo"),
        getHistoryBidInfoList: initRequest.des("获取历史招标信息").post(URL+"/bid/getHistoryBidInfoList"),

        getFilesList: initRequest.des("获取附件列表").get(JSON+"/json/filesList.json?temp="+ new Date().getTime()),

        // uploadFile: initRequest.des("文件上传接口").upload(URL+"/bid/uploadFile"),
        // uploadFile: initRequest.des("新文件上传接口").upload(URL + "/bid/uploadFileToCos"),
        uploadFile: initRequest.des("新文件上传接口").upload(B2cUrl + "/sys/uploadImg"),

    }
}